import {useState, useEffect} from 'react';
import {ServiceContainer} from '../../shared/di/ServiceContainer';
import {User} from '../../domain/auth/entities/User';
import {useAuthContext} from '../context/AuthContext';

/**
 * Legacy hook for backward compatibility
 * Use useAuthContext directly for new code
 */
export const useAuth = () => {
  // Simply re-export the context
  return useAuthContext();
};

